<template>
<div class="chapter">
<div class="inner_page">
<h1>Legends of the Black Watch</h1>
<h2 class="sigil_not_in_toc">or, Forty-second Highlanders</h2>
<h2 class="sigil_not_in_toc">James Grant</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?351c5d5f